<script>
  import { router } from '@inertiajs/svelte'
  import { Button } from '$lib/components/ui/button/index.js'
  import { Input } from '$lib/components/ui/input/index.js'
  import { Card, CardHeader, CardContent, CardFooter } from '$lib/components/ui/card/index.js'

  let { errors = {}, onboarding = true } = $props()

  let name = $state('')
  let street_address = $state('')
  let city = $state('')
  let postcode = $state('')
  let state = $state('')
  let submitting = $state(false)

  function handleSubmit(e) {
    e.preventDefault()
    if (submitting) return
    submitting = true
    router.post('/properties', { property: { name, street_address, city, postcode, state } }, {
      onFinish: () => { submitting = false }
    })
  }
</script>

<svelte:head>
  <title>{onboarding ? 'Add Your First Property' : 'Add New Property'} — MyRentalTax</title>
</svelte:head>

<div class="min-h-dvh flex flex-col items-center justify-center gap-5 px-5 py-8 bg-[#fafafa]">
  <!-- Logo -->
  <div class="flex items-center gap-3">
    <div class="w-10 h-10 sm:w-12 sm:h-12 bg-zinc-900 rounded-[10px] sm:rounded-xl flex items-center justify-center text-white flex-shrink-0">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7"/>
      </svg>
    </div>
    <span class="text-2xl sm:text-3xl font-bold text-zinc-900">MyRentalTax</span>
  </div>
  <p class="text-[13px] sm:text-base text-zinc-500 -mt-2">Malaysian Rental Income Tax Wizard — YA 2025</p>

  <form class="w-full max-w-sm sm:max-w-[520px]" onsubmit={handleSubmit}>
    <Card class="shadow-sm">
      <CardHeader class="px-5 pt-5 pb-0 sm:px-6 sm:pt-6 gap-1">
        <h2 class="text-lg sm:text-xl font-semibold text-zinc-900 m-0">{onboarding ? 'Add Your First Property' : 'Add New Property'}</h2>
        <p class="text-sm text-zinc-500 leading-relaxed m-0">{onboarding ? 'Enter your rental property details to get started with the tax wizard.' : 'Add another rental property to your tax calculation.'}</p>
      </CardHeader>

      <CardContent class="px-5 py-5 sm:px-6 flex flex-col gap-4">
        {#if errors.name}
          <div class="bg-red-50 border border-red-200 rounded-md px-3 py-2 text-sm text-red-600">{errors.name[0]}</div>
        {/if}

        <div class="flex flex-col gap-1.5">
          <label for="name" class="text-sm font-medium text-zinc-900">Property Name</label>
          <Input id="name" type="text" placeholder="e.g. Sunway Geo Residences" bind:value={name} required class="h-9" />
        </div>

        <div class="flex flex-col gap-1.5">
          <label for="street_address" class="text-sm font-medium text-zinc-900">Street Address</label>
          <Input id="street_address" type="text" placeholder="e.g. No 12, Jalan PJU 5/1" bind:value={street_address} class="h-9" />
        </div>

        <div class="flex flex-col gap-1.5">
          <label for="city" class="text-sm font-medium text-zinc-900">City</label>
          <Input id="city" type="text" placeholder="e.g. Kota Damansara" bind:value={city} class="h-9" />
        </div>

        <div class="flex gap-4">
          <div class="flex flex-col gap-1.5 flex-1">
            <label for="postcode" class="text-sm font-medium text-zinc-900">Postcode</label>
            <Input id="postcode" type="text" placeholder="e.g. 47810" bind:value={postcode} class="h-9" />
          </div>
          <div class="flex flex-col gap-1.5 flex-1">
            <label for="state" class="text-sm font-medium text-zinc-900">State</label>
            <Input id="state" type="text" placeholder="e.g. Selangor" bind:value={state} class="h-9" />
          </div>
        </div>
      </CardContent>

      <CardFooter class="px-5 pb-5 sm:px-6 sm:pb-6 flex justify-end border-t border-zinc-100 pt-4">
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Saving…' : 'Continue'}
        </Button>
      </CardFooter>
    </Card>
  </form>
</div>
